export * from './env';
export * from './maps';
export * from './mocks';
export * from './routes';

export const DEFAULT_DEBOUNCE_TIME = 1000;

export const COMMON_TRANSLATION = 'common';

export const HELIX_SUPPORT_EMAIL = 'support@helix.com';

export const COMMON_FETCH_US_COUNTIES = 'us-counties';
export const COMMON_FETCH_US_ZCTAS = 'us-zctas';
export const COMMON_FETCH_US_STATES = 'us-counties';

export const LAYOUT_ONE = 1;
export const LAYOUT_THREE = 3;
